/**
 * Single owner of the "save a Blob to the user's disk" browser dance:
 * object-URL → synthetic anchor → click → revoke. Used by every admin export
 * (the payouts CSV built client-side, the settlement CSV streamed from the BE)
 * so the object-URL lifecycle lives in exactly one place instead of being
 * re-implemented per call site.
 *
 * The anchor is attached to the document before the click and removed after —
 * some browsers ignore a click on a detached anchor. The object URL is revoked
 * on the next tick, not synchronously: a few browsers cancel or truncate the
 * download if the URL is freed before they have started reading it.
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
